export default "__VITE_ASSET__DOSTOxkW__"